import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ChallengeFilters = ({ filters, onFilterChange, onClearFilters }) => {
  const categories = [
    { value: 'all', label: 'All Categories', icon: 'Grid3X3' },
    { value: 'education', label: 'Education', icon: 'GraduationCap' },
    { value: 'healthcare', label: 'Healthcare', icon: 'Heart' },
    { value: 'environment', label: 'Environment', icon: 'Leaf' },
    { value: 'poverty', label: 'Poverty Relief', icon: 'HandHeart' },
    { value: 'disaster', label: 'Disaster Relief', icon: 'Shield' },
    { value: 'animals', label: 'Animal Welfare', icon: 'Dog' }
  ];

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'active', label: 'Active' },
    { value: 'ending-soon', label: 'Ending Soon' },
    { value: 'completed', label: 'Completed' }
  ];

  const sortOptions = [
    { value: 'newest', label: 'Newest First' },
    { value: 'ending-soon', label: 'Ending Soon' },
    { value: 'most-popular', label: 'Most Popular' },
    { value: 'highest-goal', label: 'Highest Goal' },
    { value: 'most-raised', label: 'Most Raised' }
  ];

  const hasActiveFilters = filters?.category !== 'all' || filters?.status !== 'all' || filters?.sort !== 'newest';

  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-card-foreground">Filter Challenges</h3>
        {hasActiveFilters && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearFilters}
            iconName="X"
            iconPosition="left"
          >
            Clear Filters
          </Button>
        )}
      </div>
      <div className="space-y-4">
        {/* Category Filter */}
        <div>
          <label className="text-sm font-medium text-card-foreground mb-2 block">
            Category
          </label>
          <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-2">
            {categories?.map((category) => (
              <button
                key={category?.value}
                onClick={() => onFilterChange('category', category?.value)}
                className={`flex items-center space-x-2 px-3 py-2 rounded-lg text-sm font-medium transition-micro ${
                  filters?.category === category?.value
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-muted text-muted-foreground hover:bg-muted/80 hover:text-foreground'
                }`}
              >
                <Icon name={category?.icon} size={14} />
                <span className="hidden sm:inline">{category?.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Status and Sort Filters */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Status Filter */}
          <div>
            <label className="text-sm font-medium text-card-foreground mb-2 block">
              Status
            </label>
            <div className="grid grid-cols-2 gap-2">
              {statusOptions?.map((status) => (
                <button
                  key={status?.value}
                  onClick={() => onFilterChange('status', status?.value)}
                  className={`px-3 py-2 rounded-lg text-sm font-medium transition-micro ${
                    filters?.status === status?.value
                      ? 'bg-primary text-primary-foreground'
                      : 'bg-muted text-muted-foreground hover:bg-muted/80 hover:text-foreground'
                  }`}
                >
                  {status?.label}
                </button>
              ))}
            </div>
          </div>

          {/* Sort Filter */}
          <div>
            <label className="text-sm font-medium text-card-foreground mb-2 block">
              Sort By
            </label>
            <select
              value={filters?.sort}
              onChange={(e) => onFilterChange('sort', e?.target?.value)}
              className="w-full px-3 py-2 bg-input border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
            >
              {sortOptions?.map((option) => (
                <option key={option?.value} value={option?.value}>
                  {option?.label}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Search */}
        <div>
          <label className="text-sm font-medium text-card-foreground mb-2 block">
            Search Challenges
          </label>
          <div className="relative">
            <Icon 
              name="Search" 
              size={16} 
              className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" 
            />
            <input
              type="text"
              placeholder="Search by title, description, or cause..."
              value={filters?.search || ''}
              onChange={(e) => onFilterChange('search', e?.target?.value)}
              className="w-full pl-10 pr-4 py-2 bg-input border border-border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChallengeFilters;